import { LocationSlugs } from '@appTypes/nafLocations';
import { NafLocationsMapBlockType } from '@appTypes/NafLocationsMapBlockType';

export const EMPTY_COUNTIES: string[] = [];

export const sourceToSlug = (block?: NafLocationsMapBlockType): LocationSlugs => {
  const source = block?.nafLocationPath;

  if (source === 'practice-tracks') {
    return LocationSlugs.practiceTracks;
  }

  return LocationSlugs.nafCenters;
};

export const createLocationUrl = (locationSlug: LocationSlugs, slug: string) => {
  if (locationSlug === LocationSlugs.practiceTracks) {
    return `/her-finner-du-naf/naf-ovingsbaner/${slug}`;
  }

  return `/bilverksted-og-tester/naf-senter/${slug}`;
};
